import { useMemo } from "react";
import { useChartOfAccountsTemplates } from "@api/coaTemplate.api";
import { useWorkspaceDetails } from "@api/workspace.api";
import { isTemplateAllowedForNewEntity } from "@common/helpers/chartOfAccountsTemplateApplicability";

interface Params {
    workspaceId?: string;
}

export function useNewClientCoaTemplates({ workspaceId }: Params = {}) {
    const { data, isFetched: areTemplatesFetched } =
        useChartOfAccountsTemplates();
    const { data: workspaceDetails, isFetched: isWorkspaceFetched } =
        useWorkspaceDetails(workspaceId);

    const isGlFirstEnabled = workspaceId
        ? workspaceDetails?.workspace.glFirstEnabledAt != null
        : true;

    const templates = useMemo(
        () =>
            data?.filter((template) =>
                isTemplateAllowedForNewEntity({
                    template,
                    isGlFirstEnabled,
                }),
            ),
        [data, isGlFirstEnabled],
    );

    return {
        templates,
        isFetched: areTemplatesFetched && (!workspaceId || isWorkspaceFetched),
    };
}
